// src/data/CoursesData.js
export const courseData = [
  // DESIGNING (Mechanical)
  {
    id: 1,
    category: 'Designing (Mechanical)',
    name: 'ENGINEERING DRAFTING',
    duration: '6 Weeks',
    fee: '8,000',
    level: 'Beginner'
  },
  {
    id: 2,
    category: 'Designing (Mechanical)',
    name: 'AUTOCAD MECHANICAL',
    duration: '6 Weeks',
    fee: '12,000',
    level: 'Beginner'
  },
  {
    id: 3,
    category: 'Designing (Mechanical)',
    name: '3D CADCAM',
    duration: '6 Weeks',
    fee: '10,000',
    level: 'Intermediate'
  },
  {
    id: 4,
    category: 'Designing (Mechanical)',
    name: 'SOLID WORKS',
    duration: '4 Weeks',
    fee: '12,000',
    level: 'Intermediate'
  },
  {
    id: 5,
    category: 'Designing (Mechanical)',
    name: 'Pro-E',
    duration: '4 Weeks',
    fee: '12,000',
    level: 'Intermediate'
  },
  {
    id: 6,
    category: 'Designing (Mechanical)',
    name: 'MOLD DESIGNING',
    duration: '6 Weeks',
    fee: '10,000',
    level: 'Advanced'
  },
  {
    id: 7,
    category: 'Designing (Mechanical)',
    name: 'JIGS & FIXTURES DESIGNING',
    duration: '6 Weeks',
    fee: '10,000',
    level: 'Advanced'
  },
  {
    id: 8,
    category: 'Designing (Mechanical)',
    name: 'PRESS TOOL DESIGN',
    duration: '6 Weeks',
    fee: '10,000',
    level: 'Advanced'
  },
  {
    id: 9,
    category: 'Designing (Mechanical)',
    name: 'CUTTING TOOL DESIGN',
    duration: '6 Weeks',
    fee: '10,000',
    level: 'Advanced'
  },

  // Mechanical Manufacturing
  {
    id: 10,
    category: 'Mechanical Manufacturing',
    name: 'CNC MACHINING CENTER',
    duration: '4 Weeks',
    fee: '10,000',
    level: 'Intermediate'
  },
  {
    id: 11,
    category: 'Mechanical Manufacturing',
    name: 'CNC TURNING CENTER',
    duration: '6 Weeks',
    fee: '10,000',
    level: 'Intermediate'
  },
  {
    id: 12,
    category: 'Mechanical Manufacturing',
    name: 'CNC EDM SINKER + WIRECUT',
    duration: '4 Weeks',
    fee: '8,000',
    level: 'Intermediate'
  },
  {
    id: 13,
    category: 'Mechanical Manufacturing',
    name: 'CNC INJECTION MOULDING',
    duration: '3 Weeks',
    fee: '8,000',
    level: 'Intermediate'
  },
  {
    id: 14,
    category: 'Mechanical Manufacturing',
    name: 'BASIC MACHINE SHOP',
    duration: '6 Weeks',
    fee: '8,000',
    level: 'Beginner'
  },
  {
    id: 15,
    category: 'Mechanical Manufacturing',
    name: 'DIE & MOLD MANUFACTURING',
    duration: '12 Weeks',
    fee: '14,500',
    level: 'Advanced'
  },
  {
    id: 16,
    category: 'Mechanical Manufacturing',
    name: 'COMPUTER FOUNDATION',
    duration: '6 Weeks',
    fee: '8,000',
    level: 'Beginner'
  },
  {
    id: 17,
    category: 'Mechanical Manufacturing',
    name: 'GRAPHIC DESIGN',
    duration: '12 Weeks',
    fee: '13,000',
    level: 'Intermediate'
  },

  // CIVIL
  {
    id: 18,
    category: 'Civil',
    name: 'QUANTITY SURVEYOR',
    duration: '6 Weeks',
    fee: '10,000',
    level: 'Intermediate'
  },
  {
    id: 19,
    category: 'Civil',
    name: 'AUTOCAD CIVIL',
    duration: '6 Weeks',
    fee: '10,000',
    level: 'Beginner'
  },
  {
    id: 20,
    category: 'Civil',
    name: 'QUANTITY SURVEYOR + AUTOCAD CIVIL',
    duration: '8 Weeks',
    fee: '15,000',
    level: 'Intermediate'
  },
  {
    id: 21,
    category: 'Civil',
    name: 'PLUMBER & PIPE TECHNICIAN',
    duration: '6 Weeks',
    fee: '8,000',
    level: 'Beginner'
  },
  {
    id: 22,
    category: 'Civil',
    name: 'INSPECTION & MEASURING TECHNIQUE',
    duration: '6 Weeks',
    fee: '8,000',
    level: 'Intermediate'
  },
  {
    id: 23,
    category: 'Civil',
    name: 'CMM - COORDINATE MEASURING MACHINE',
    duration: '4 Weeks',
    fee: '8,000',
    level: 'Intermediate'
  },
  {
    id: 24,
    category: 'Civil',
    name: 'QUALITY INSPECTOR',
    duration: '6 Weeks',
    fee: '12,000',
    level: 'Intermediate'
  },
  {
    id: 25,
    category: 'Civil',
    name: 'CALIBRATION LABORATORY TECHNICIAN',
    duration: '2 Weeks',
    fee: '10,000',
    level: 'Advanced'
  },

  // Welding & Fabrication
  {
    id: 26,
    category: 'Welding & Fabrication',
    name: 'BASIC WELDING',
    duration: '6 Weeks',
    fee: '8,000',
    level: 'Beginner'
  },
  {
    id: 27,
    category: 'Welding & Fabrication',
    name: 'TIG WELDING',
    duration: '4 Weeks',
    fee: '10,000',
    level: 'Intermediate'
  },
  {
    id: 28,
    category: 'Welding & Fabrication',
    name: 'MIG WELDING',
    duration: '4 Weeks',
    fee: '10,000',
    level: 'Intermediate'
  },
  {
    id: 29,
    category: 'Welding & Fabrication',
    name: '6G MULTI WELDING',
    duration: '4 Weeks',
    fee: '28,000',
    level: 'Advanced'
  },
  {
    id: 30,
    category: 'Welding & Fabrication',
    name: 'NDT LEVEL 1',
    duration: '1 Week',
    fee: '25,000',
    level: 'Beginner'
  },
  {
    id: 31,
    category: 'Welding & Fabrication',
    name: 'NDT LEVEL 2',
    duration: '1 Week',
    fee: '25,000',
    level: 'Intermediate'
  },
  {
    id: 32,
    category: 'Welding & Fabrication',
    name: 'REFRIGERATION AND AIR CONDITIONING',
    duration: '8 Weeks',
    fee: '10,500',
    level: 'Intermediate'
  },

  // Electrical & Electronics
  {
    id: 33,
    category: 'Electrical & Electronics',
    name: 'INDUSTRIAL ELECTRICIAN',
    duration: '8 Weeks',
    fee: '10,500',
    level: 'Beginner'
  },
  {
    id: 34,
    category: 'Electrical & Electronics',
    name: 'AUTOCAD ELECTRICAL',
    duration: '6 Weeks',
    fee: '10,000',
    level: 'Beginner'
  },
  {
    id: 35,
    category: 'Electrical & Electronics',
    name: 'PLC-HMI',
    duration: '12 Weeks',
    fee: '21,000',
    level: 'Advanced'
  },
  {
    id: 36,
    category: 'Electrical & Electronics',
    name: 'INSTRUMENTATION & PROCESS CONTROL',
    duration: '6 Weeks',
    fee: '10,000',
    level: 'Intermediate'
  },

  // Language
  {
    id: 37,
    category: 'Language',
    name: 'SPOKEN ENGLISH',
    duration: '6 Weeks',
    fee: '8,000',
    level: 'Beginner'
  },
  {
    id: 38,
    category: 'Language',
    name: 'ENGLISH GRAMMAR',
    duration: '6 Weeks',
    fee: '8,000',
    level: 'Beginner'
  },
  {
    id: 39,
    category: 'Language',
    name: 'IELTS PREPARATION',
    duration: '6 Weeks',
    fee: '15,000',
    level: 'Intermediate'
  },

  // Health & Safety
  {
    id: 40,
    category: 'Health & Safety',
    name: 'SAFETY & HEALTH OFFICER',
    duration: '6 Weeks',
    fee: '15,000',
    level: 'Intermediate'
  },

  // EV
  {
    id: 41,
    category: 'EV',
    name: 'EV TECHNICIAN',
    duration: '4 Weeks',
    fee: '12,000',
    level: 'Intermediate'
  },

  // AI & Technology
  {
    id: 42,
    category: 'AI & Technology',
    name: 'NETWORKING & CLOUD COMPUTING',
    duration: '3 Months',
    fee: '25,000',
    level: 'Intermediate'
  },
  {
    id: 43,
    category: 'AI & Technology',
    name: 'MACHINE LEARNING & DEEP LEARNING',
    duration: '3 Months',
    fee: '25,000',
    level: 'Advanced'
  },
  {
    id: 44,
    category: 'AI & Technology',
    name: 'WEB DEVELOPMENT WITH PYTHON AI',
    duration: '6 Months',
    fee: '30,000',
    level: 'Advanced'
  },
  {
    id: 45,
    category: 'AI & Technology',
    name: 'AI BASED GRAPHIC DESIGNING',
    duration: '3 Months',
    fee: '33,000',
    level: 'Advanced'
  },
  {
    id: 46,
    category: 'AI & Technology',
    name: 'CYBER SECURITY',
    duration: '3 Months',
    fee: '42,000',
    level: 'Advanced'
  },
  {
    id: 47,
    category: 'AI & Technology',
    name: 'SHOPIFY AI MASTERY BOOTCAMP',
    duration: '3 Months',
    fee: '37,500',
    level: 'Advanced'
  },
  {
    id: 48,
    category: 'AI & Technology',
    name: 'DIGITAL MEDIA MARKETING & ANALYTICS',
    duration: '3 Months',
    fee: '33,000',
    level: 'Intermediate'
  },
  {
    id: 49,
    category: 'AI & Technology',
    name: 'ARTIFICIAL INTELLIGENCE BOOTCAMP',
    duration: '4 Months',
    fee: '60,000',
    level: 'Advanced'
  },
  {
    id: 50,
    category: 'AI & Technology',
    name: 'VIDEO EDITING & YOUTUBE',
    duration: '3 Months',
    fee: '37,500',
    level: 'Intermediate'
  },
  {
    id: 51,
    category: 'AI & Technology',
    name: 'WEB DEVELOPMENT',
    duration: '3 Months',
    fee: '33,000',
    level: 'Intermediate'
  },
  {
    id: 52,
    category: 'AI & Technology',
    name: 'AMAZON',
    duration: '3 Months',
    fee: '37,500',
    level: 'Intermediate'
  },

  // Foundry & Metal Treatment
  {
    id: 53,
    category: 'Foundry & Metal Treatment',
    name: 'FOUNDRY TECHNIQUES',
    duration: '6 Weeks',
    fee: '8,000',
    level: 'Beginner'
  },
  {
    id: 54,
    category: 'Foundry & Metal Treatment',
    name: 'HEAT TREATMENT TECHNIQUES',
    duration: '6 Weeks',
    fee: '8,000',
    level: 'Intermediate'
  },

  // Pattern, Carpenter & CNC Wood Router
  {
    id: 55,
    category: 'Pattern, Carpenter & CNC Wood Router',
    name: 'PATTERN MAKING',
    duration: '6 Weeks',
    fee: '8,000',
    level: 'Beginner'
  },
  {
    id: 56,
    category: 'Pattern, Carpenter & CNC Wood Router',
    name: 'CARPENTER',
    duration: '12 Weeks',
    fee: '20,000',
    level: 'Intermediate'
  },
  {
    id: 57,
    category: 'Pattern, Carpenter & CNC Wood Router',
    name: 'CNC WOOD ROUTER',
    duration: '2 Weeks',
    fee: '10,000',
    level: 'Beginner'
  },

  // Renewable Energy (Solar)
  {
    id: 58,
    category: 'Renewable Energy (Solar)',
    name: 'SOLAR SYSTEM DESIGNING & INSTALLATION',
    duration: '4 Weeks',
    fee: '10,000',
    level: 'Intermediate'
  }
];